/* Register all custom elements before the HTML parser sees them, so that older browsers won't drop them */
ko.components.register('popup-help', { template: { require: 'text!widgets/popup-help.html' } });

ko.components.register('info-tile', { require: 'widgets/info-tile' });
ko.components.register('action-link', { require: 'widgets/action-link' });
ko.components.register('customers-page', { require: 'pages/customers/customers-page' });

console.log('Registered!');
